import "./FoodDetailsModal.css";

import {
  MdClose,
  MdAccessTime,
  MdCategory,
  MdCurrencyRupee,
  MdRestaurantMenu,
  MdLocalOffer,
} from "react-icons/md";

import FoodStatusBadge from "../FoodCard/FoodStatusBadge/FoodStatusBadge";
import getImageUrl from "../../../../../../utils/imageUrl";



function FoodDetailsModal({
  open,
  food,
  onClose,
}) {
  if (!open || !food) return null;

const imageUrl = food.image
  ? getImageUrl(food.image)
  : "/images/food-placeholder.png";

  return (
    <div className="food-details-overlay">

      <div className="food-details-modal">

        <button
          className="food-details-close"
          onClick={onClose}
        >
          <MdClose />
        </button>

        <div className="food-details-image">

          <img
            src={imageUrl}
            alt={food.foodName}
          />

        </div>

        <div className="food-details-content">

          <h2>{food.foodName}</h2>

          <p className="food-description">
            {food.description}
          </p>

          <div className="food-details-grid">

            <div className="detail-card">
              <MdCategory />
              <div>
                <span>Category</span>
                <strong>{food.category}</strong>
              </div>
            </div>

            <div className="detail-card">
              <MdRestaurantMenu />
              <div>
                <span>Food Type</span>
                <strong>{food.foodType}</strong>
              </div>
            </div>

            <div className="detail-card">
              <MdCurrencyRupee />
              <div>
                <span>Price</span>
                <strong>₹{food.offerPrice || food.price}</strong>
              </div>
            </div>

            <div className="detail-card">
              <MdAccessTime />
              <div>
                <span>Preparation</span>
                <strong>{food.preparationTime} mins</strong>
              </div>
            </div>

          </div>

          <div className="food-status-section">
            <FoodStatusBadge
              isAvailable={food.isAvailable}
            />
          </div>

          <div className="food-tags">

            {food.isBestSeller && (
              <span>Bestseller</span>
            )}

            {food.availableToday && (
              <span>Today's Special</span>
            )}

            {food.tags?.map((tag) => (
              <span key={tag}>
                <MdLocalOffer />
                {tag}
              </span>
            ))}

          </div>

        </div>

      </div>

    </div>
  );
}

export default FoodDetailsModal;